export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    shared = _ref.shared,
    _ref$toggledFeatures = _ref.toggledFeatures,
    toggledFeatures = _ref$toggledFeatures === void 0 ? {} : _ref$toggledFeatures;
  shared.toggledFeatures = toggledFeatures; // eslint-disable-line no-param-reassign
  return {
    toggledFeatures
  };
});